function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function checkCookie(name) {
  let user = getCookie(name);
  if (user == "" || user == null) {
    return false
  }
  return true
}

$(window).load(function () {
  if ($(".disclaimer-container").length) {
    console.log("Cookies", checkCookie("client-major"));
    if(!checkCookie("client-major")) {
      $(".disclaimer-container").addClass('visible');
    }
  }
  document.querySelector(".btn-true").addEventListener('click', () => {
    setCookie("client-major", "yes", 1);
     $(".disclaimer-container").removeClass("visible");
  })
  document.querySelector(".btn-false").addEventListener('click', () => {
    $(".disclaimer-container .not-allowed").addClass("visible");
  })
});
